import React from 'react'
import PropTypes from 'prop-types'

const AssignManagerButton = props => (
  <div className="col-md-2 page-title">
    <button
      type="button"
      style={{
        fontSize: '14px',
        backgroundColor: '#659be0',
        color: 'white',
        width: '75%',
        padding: '6px 12px',
      }}
      onClick={props.onClick}
      disabled={props.isDisabled}
    >
      {props.children}
    </button>
  </div>
)

AssignManagerButton.propTypes = {
  func: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
}

export default AssignManagerButton
